import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

export interface BulkDeleteModalConfig {
  title?: string;
  message?: string;
  items: any[];
}

//TODO rinominare il componente in bulk operation
@Component({
    selector: 'app-bulk-delete-modal',
    templateUrl: './bulk-delete-modal.component.html',
    styleUrls: ['./bulk-delete-modal.component.scss'],
    imports: [TranslatePipe]
})
export class BulkDeleteModalComponent implements OnInit {
  @Input() config!: BulkDeleteModalConfig;
  
  @Output() confirmAction = new EventEmitter();


  constructor(
    public activeModal: NgbActiveModal,
    private ts: TranslateService,
  ) {}

  ngOnInit(): void {}

  getTitle() {
    const title = this.config.title ? this.config.title! : 'GLOBAL.DELETE';
    return  this.ts.instant(title);
  }

  getMessage() {
    const message = this.config.message ? this.config.message! : 'GLOBAL.BULK_DELETE_TITLE';
    return  this.ts.instant(message);
  }

  confirm(): void {
    this.confirmAction.emit();
    this.activeModal.close();
  }

}
